import { useScrapeStore } from '../store/scrapeStore';

/* Thin HTTP client for the Cloudflare "Scrape-to-CAD" learning Worker. Every
   request carries the account so Vectorize namespaces + D1 rows stay scoped. */
function base() {
    const b = useScrapeStore.getState().workerBase.replace(/\/$/, '');
    if (!b) throw new Error('Set your Cloudflare Worker URL in Settings → AI Training.');
    return b;
}
async function post(path, body) {
    const res = await fetch(`${base()}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) throw new Error(data.error || `Worker error (HTTP ${res.status})`);
    return data;
}

/* Reachability / config validation for the Settings UI. */
export async function testConnection() {
    const b = base();
    const res = await fetch(b);
    return res.ok;
}

/* Route a manual URL → Worker fetches + extracts technical text. */
export async function scrapeUrl(url) {
    return post('/scrape', { url });
}

/* Upsert a vector into Vectorize (account namespace) + D1 relational rows. */
export async function ingest({ account_id, project_id, source, title, body, vector, url }) {
    return post('/ingest', { account_id, project_id, source, title, body, vector, url });
}

/* Vectorize cosine search of the account namespace for Command Bar knowledge. */
export async function queryKnowledge({ account_id, vector, topK = 5 }) {
    return post('/query', { account_id, vector, topK });
}

/* Relational D1 tracking of a user viewport modification. */
export async function logMutation({ account_id, project_id, action, payload }) {
    return post('/mutations', { account_id, project_id, action, payload });
}